// Варианты товара в карточке списка — кружки 14 px: не больше 7 штук и «+N».
// Остальные поля и картинки 2x занимают треть window.__NUXT__ страницы раздела.
const VARIANTS_RENDER_LIMIT = 7

const trimVariant = (variant: any) => ({
  title: variant.title,
  url: variant.url,
  active: variant.active,
  image:
    variant.image && variant.image['1x']
      ? { '1x': variant.image['1x'] }
      : variant.image,
})

export const trimProductAspects = (items: any[]) => {
  items.forEach((item) => {
    if (!Array.isArray(item.aspects)) return
    item.aspects = item.aspects.map((aspect: any) => ({
      ...aspect,
      // Хвост нужен только для подсчёта «+N»
      variants: (aspect.variants || []).map((variant: any, index: number) =>
        index < VARIANTS_RENDER_LIMIT ? trimVariant(variant) : {}
      ),
    }))
  })
}
